import dayjs from "dayjs";

// Shared constants
export const TIME_RANGES = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 Days", value: "this week" },
  { label: "Last 15 Days", value: "last 15 days" },
  { label: "Last 30 Days", value: "one month" },
  { label: "Last 3 Months", value: "three months" },
  { label: "Last 6 Months", value: "six months" },
  { label: "Custom", value: "custom" },
];

// Helper function to get default date range (6 months)
export const getDefaultDateRange = () => {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - 6);
  return { from: start, to: end };
};

// Calculate date range based on time range selection
export const calculateDateRange = (selectedTimeRange, startDate = "", endDate = "") => {
  if (selectedTimeRange === "custom") {
    return { newStartDate: startDate, newEndDate: endDate };
  }

  const now = dayjs();
  let newStartDate, newEndDate;

  switch (selectedTimeRange) {
    case "today":
      newStartDate = now.startOf("day");
      newEndDate = now.endOf("day");
      break;
    case "yesterday":
      newStartDate = now.subtract(1, "day").startOf("day");
      newEndDate = now.subtract(1, "day").endOf("day");
      break;
    case "this week":
      newStartDate = now.subtract(7, "day").startOf("day");
      newEndDate = now.endOf("day");
      break;
    case "last 15 days":
      newStartDate = now.subtract(14, "day").startOf("day");
      newEndDate = now.endOf("day");
      break;
    case "one month":
      newStartDate = now.subtract(1, "month").startOf("day");
      newEndDate = now.endOf("day");
      break;
    case "three months":
      newStartDate = now.subtract(3, "month").startOf("day");
      newEndDate = now.endOf("day");
      break;
    case "six months":
      newStartDate = now.subtract(6, "month").startOf("day");
      newEndDate = now.endOf("day");
      break;
    default:
      newStartDate = now.startOf("day");
      newEndDate = now.endOf("day");
  }

  return {
    newStartDate: newStartDate.toISOString(),
    newEndDate: newEndDate.toISOString(),
  };
};

// Handle custom date range selection for API
export const formatCustomDateRange = (range) => {
  if (!range || !range.from || !range.to) {
    return null;
  }

  // For API calls - use UTC with full day boundaries
  const apiStartDate = new Date(range.from);
  apiStartDate.setUTCHours(0, 0, 0, 0);
  const apiEndDate = new Date(range.to);
  apiEndDate.setUTCHours(23, 59, 59, 999);

  const startDateISO = apiStartDate.toISOString();
  const endDateISO = apiEndDate.toISOString();

  // For display in date picker
  const displayStartDate = new Date(range.from);
  displayStartDate.setHours(0, 0, 0, 0);
  const displayEndDate = new Date(range.to);
  displayEndDate.setHours(0, 0, 0, 0);

  return {
    apiDates: { startDate: startDateISO, endDate: endDateISO },
    displayDates: { from: displayStartDate, to: displayEndDate }
  };
};
